module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-5.f37de985.jpg";